"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLAIM_AGGREGATOR = void 0;
const types_1 = require("../types");
exports.CLAIM_AGGREGATOR = {
    [types_1.Networks.Ropsten]: '0x2078270ae9956f1298f8bfd8be43306bbd4ab551',
    [types_1.Networks.Mainnet]: '0x5287cac629be59997602b4177cb4420165264b69',
    [types_1.Networks.Polygon]: '0x718Cd1D06094b53de74dE745c4EAD3AC629a0c98',
    [types_1.Networks.Arbitrum]: '0x95887654d8646C26fAb33F344576E2E74b211256',
    [types_1.Networks.Avalanche]: '0x5e169082fFf23cEE6766062B96051A78c543127D',
    [types_1.Networks.Moonriver]: '0x772a82D27b1024e9072aE33dCEd3C0DF1FbDA66e',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
